module.exports = __webpack_public_path__ + "img/newLoginTop.9547b746.png";